var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "projectUpload",
      staticStyle: { "min-width": "500px", "padding-bottom": "5px" },
    },
    [
      _c(
        "div",
        { staticStyle: { "padding-bottom": "5px" } },
        [
          _vm.fileList.length > 0
            ? _c("div", { staticStyle: { "margin-bottom": "5px" } }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      width: "100%",
                      "min-height": "425px",
                      border: "1px solid #DCDFE6",
                    },
                  },
                  [
                    _c("img", {
                      staticStyle: {
                        width: "100%",
                        height: "100%",
                        "object-fit": "contain",
                        cursor: "pointer",
                        padding: "1px",
                      },
                      attrs: { src: _vm.getImgPath(_vm.currentFile) },
                      on: {
                        click: function ($event) {
                          return _vm.showPic()
                        },
                      },
                    }),
                  ]
                ),
                _c("div", { staticStyle: { clear: "both" } }),
              ])
            : _vm._e(),
          _c(
            "el-row",
            [
              _vm._l(_vm.fileList, function (item, index) {
                return _c(
                  "div",
                  {
                    key: item.id,
                    staticStyle: {
                      float: "left",
                      width: "80px",
                      position: "relative",
                    },
                  },
                  [
                    _c("el-image", {
                      class: _vm.isFocusImg(item)
                        ? "imgBorder imgClass"
                        : "imgClass",
                      attrs: { src: _vm.getImgPath(item) },
                      on: {
                        click: function ($event) {
                          return _vm.navToImg(item, index)
                        },
                        error: function ($event) {
                          return _vm.hideErrorImage(item)
                        },
                      },
                    }),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.readOnly,
                            expression: "!readOnly",
                          },
                        ],
                        staticClass: "image-remove-icon",
                        style:
                          "border-color:" +
                          _vm.defaultTheme +
                          " !important; cursor: pointer; ",
                        on: {
                          click: function ($event) {
                            return _vm.del(item.id)
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "el-icon-close",
                          style:
                            item.imgEmpty || item.filesIn == ""
                              ? "display:block !important;color:" +
                                _vm.defaultTheme +
                                " !important;top:0px;right:0px;"
                              : "display:block !important;top:0px;right:0px;",
                        }),
                      ]
                    ),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.readOnly,
                            expression: "!readOnly",
                          },
                        ],
                        staticClass: "image-edit-icon",
                        style:
                          "border-color:" +
                          _vm.defaultTheme +
                          " !important; cursor: pointer; ",
                        on: {
                          click: function ($event) {
                            return _vm.edit(item.id)
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "el-icon-edit-outline",
                          style:
                            item.imgEmpty || item.filesIn == ""
                              ? "display:block !important;color:" +
                                _vm.defaultTheme +
                                " !important;top:0px;right:0px;"
                              : "display:block !important;top:0px;right:0px;",
                        }),
                      ]
                    ),
                  ],
                  1
                )
              }),
              _vm.readOnly
                ? _c("div", { staticClass: "buttonDiv" }, [
                    _c(
                      "div",
                      {
                        staticClass: "buttonClass",
                        attrs: { disabled: false },
                        on: { click: _vm.refreshList },
                      },
                      [
                        _c("i", {
                          staticClass: "el-icon-refresh",
                          staticStyle: {
                            "font-size": "28px",
                            color: "#8c939d",
                          },
                        }),
                      ]
                    ),
                  ])
                : _vm._e(),
              !_vm.readOnly
                ? _c("div", { staticClass: "buttonDiv" }, [
                    _c(
                      "div",
                      {
                        staticClass: "buttonClass",
                        attrs: { disabled: false },
                        on: { click: _vm.add },
                      },
                      [
                        _vm._v(_vm._s(_vm.readOnly) + " "),
                        _c("i", {
                          staticClass: "el-icon-plus",
                          staticStyle: {
                            "font-size": "28px",
                            color: "#8c939d",
                          },
                        }),
                      ]
                    ),
                  ])
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _c("itemActivityForm", {
        ref: "itemActivityForm",
        attrs: { fileStorePath: _vm.fileStorePath },
        on: {
          refreshDataList: _vm.refreshList,
          canceladd: _vm.delWithoutConfirm,
        },
      }),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false",
            },
          ],
          staticClass: "images",
        },
        _vm._l(_vm.allImg, function (item, index) {
          return _c("img", {
            key: index,
            attrs: { src: item.src, alt: item.alt },
          })
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }